import React from 'react'
import OptionChain from "../../../Components/ExtraComponents/OptionChain/Opation_Chain"
const Opation_Chain = () => {
  return (
    <div><OptionChain /></div>
  )
}

export default Opation_Chain